import {
  DataTableFilter,
  FilterType,
  ProjectManagementProjectFilter,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import BillableTag from 'modules/project_management/components/labelTags/BillableTag'

const options = () => {
  return [
    {
      label: i18n.t('project_management.projects.is_billable.billable'),
      value: true,
      component: <BillableTag isBillable />,
    },
    {
      label: i18n.t('project_management.projects.is_billable.non_billable'),
      value: false,
      component: <BillableTag isBillable={false} />,
    },
  ]
}

export const BillableFilter = (): DataTableFilter<ProjectManagementProjectFilter> => {
  return {
    type: FilterType.Boolean,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: options(),
      },
    ],
    identifier: 'billableFilter',
    path: 'isBillable',
    title: i18n.t('project_management.table.projects_list.headers.billing'),
    default: true,
  }
}
